import React from "react";
import { Modal, ModalBody, ModalHeader, Gapped, Radio, RadioGroup } from "@skbkontur/react-ui";
import { Button, ModalFooter } from "react-ui";
import { Fit, RowStack } from "@skbkontur/react-stack-layout";

import { ClearPageMethod } from "../../../../Engine/ActionCreators/UnitActionCreators";

interface UnitClearConfirmModalProps {
    name?: string | null;
    hasChildren?: boolean;
    keepChildrenCustomText?: string;
    clearChildrenCustomText?: string;
    onClear: (method: ClearPageMethod) => void;
    onClose: () => void;
}

export const UnitClearConfirmModal = (props: UnitClearConfirmModalProps) => {
    const [clearMethod, setClearMethod] = React.useState(ClearPageMethod.OnlyParent);

    const handleSubmit = () => {
        props.onClear(clearMethod);
    };

    return (
        <Modal onClose={props.onClose}>
            <ModalHeader>{`Очистить${props.name ? ` ${props.name}` : ""}?`}</ModalHeader>
            <ModalBody>
                <Gapped vertical gap={20}>
                    <div>Будут очищены все поля без возможности восстановить данные.</div>
                    {props.hasChildren && (
                        <RadioGroup value={clearMethod} onValueChange={setClearMethod}>
                            <Gapped vertical gap={20}>
                                <Radio value={ClearPageMethod.OnlyParent} data-tid={ClearPageMethod.OnlyParent}>
                                    {`Оставить ${props.keepChildrenCustomText ?? "вложенные разделы и данные в них"}`}
                                </Radio>
                                <Radio
                                    value={ClearPageMethod.ParentAndChildren}
                                    data-tid={ClearPageMethod.ParentAndChildren}>
                                    {`Удалить ${props.clearChildrenCustomText ?? "вложенные разделы"}`}
                                </Radio>
                            </Gapped>
                        </RadioGroup>
                    )}
                </Gapped>
            </ModalBody>
            <ModalFooter>
                <RowStack gap={2}>
                    <Fit>
                        <Button
                            onClick={handleSubmit}
                            size="medium"
                            use={"danger"}
                            data-tid={"UnitClearConfirmModalSubmitButton"}>
                            Очистить
                        </Button>
                    </Fit>
                    <Fit>
                        <Button onClick={props.onClose} size="medium" data-tid={"UnitClearConfirmModalCancelButton"}>
                            Отменить
                        </Button>
                    </Fit>
                </RowStack>
            </ModalFooter>
        </Modal>
    );
};
